import { render, staticRenderFns } from "./InputGroupIngredientsSubAccordian.vue?vue&type=template&id=b3108600"
import script from "./InputGroupIngredientsSubAccordian.vue?vue&type=script&lang=js"
export * from "./InputGroupIngredientsSubAccordian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports